import { Route, Routes, useLocation, Outlet, Navigate } from 'react-router-dom';
import { useContext, useLayoutEffect } from 'react';
import { AuthContext } from 'src/contexts';
import AppLayout from 'src/layout/AppLayout';
import DashboardLayout from 'src/layout/DashboardLayout';
import Home from 'src/pages/Home';
import Signup from 'src/pages/Signup';
import Signin from 'src/pages/Signin';
import ForgotPassword from 'src/pages/ForgotPassword';
import OneTimePassword from 'src/pages/OneTimePassword';
import NewPassword from 'src/pages/NewPassword';
import DashboardHome from 'src/pages/protected/DashboardHome';
import CreateCampaign from 'src/pages/protected/CreateCampaign';
import YourCampaign from 'src/pages/protected/YourCampaign';
import YourAccount from 'src/pages/protected/YourAccount';
import AccountSetup from 'src/pages/protected/AccountSetup';
import CreativeDevelopers from 'src/pages/protected/CreativeDevelopers';
import FacebookCallback from 'src/components/pages/facebook/FacebookCallback';
import InstagramCallback from 'src/components/pages/instagram/InstagramCallback';
import ProtectedRoutePolicy from './ProtectedRoutePolicy';
import ProtectedRoute from './ProtectedRoute';
import CampaignPerformance from 'src/pages/protected/CampaignPerformance';
import PrivacyPolicy from 'src/pages/PrivacyPolicy';
import YourAudience from 'src/pages/protected/YourAudience';
import YourCreatives from 'src/pages/protected/YourCreatives';
import WebsiteCrmLinking from 'src/pages/protected/WebsiteCrmLinking';
import ContactUs from 'src/pages/protected/ContactUs';

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    const mainElement = document.getElementById('app-layout-main');
    if (mainElement) {
      mainElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [location.pathname]);

  return children;
};

export default function AppRouter() {
  const { profile } = useContext(AuthContext);
  console.log(profile, 'this is profile');

  return (
    <Wrapper>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<AppLayout />}>
          <Route index element={<Home />} />
          <Route path="signup" element={<Signup />} />
          <Route path="signin" element={<Signin />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="one-time-password" element={<OneTimePassword />} />
          <Route path="new-password" element={<NewPassword />} />
          <Route path="facebook/callback" element={<FacebookCallback />} />
          <Route path="instagram/callback" element={<InstagramCallback />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="contact-us" element={<ContactUs />} />

        </Route>

        {/* Protected Routes (Dashboard) */}
        <Route path="/dashboard" element={<ProtectedRoutePolicy template={<DashboardLayout />} />}>
          <Route index element={<DashboardHome />} />
          <Route path="create-campaign" element={<CreateCampaign />} />
          <Route path="your-campaign" element={<YourCampaign />} />
          <Route path="campaign-performance/:campaignId" element={<CampaignPerformance />} />
          <Route path="your-account" element={<YourAccount />} />
          <Route path="account-setup" element={<AccountSetup />} />
          <Route path="creative-developers" element={<CreativeDevelopers />} />
          <Route path="your-audience" element={<YourAudience />} />
          <Route path="your-creatives" element={<YourCreatives />} />
          <Route path="website-crm-linking" element={<WebsiteCrmLinking />} />
        </Route>

        {/* Redirect logged-in users to dashboard */}
        <Route element={<ProtectedRoute isAccess={!!profile} />}>
          <Route path="dashboard" element={<Navigate to="/dashboard" />} />
        </Route>

        {/* Redirect unknown routes to home */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Wrapper>
  );
}
